export const About = () => {
  return (
    <div className="page-container">
      <div className="container">
      <div className="row align-items-center">
        <div className="py-3 py-md-5">
          <h1 className="display-3">Fat Bear Week 2022!</h1>
          <p className="lead text-dark">
            Every year Katmai National Park runs a "Fat Bear Week" competition.
            To get ready for hibernation during the long, cold winter, bears need to bulk up in preparation.
            This provides an excellent opportunity for some good competitive fun!
            Brackets are released Monday, October 3, 7 p.m. Eastern / 4p.m. Pacific, and the competition runs from October 5 - October 11.
          </p>
          <h3 className="display-4">
            Scoring
          </h3>
          <p className="lead text-dark">
            1st round: 2 points<br/>
            2nd round: 3 points<br/>
            3rd round: 5 points<br/>
            4th round: 8 points
          </p>
          <h3 className="display-4">
            Buy-in and Payouts
          </h3>
          <p className="lead text-dark">
            In the future this site will be more dynamic with each league manager able to decide buy-in and payouts.
            But for now, it's just us! Buy-in is $30. 
            At 8 members per league, 1/3 of the pot ($80) is donated to Katmai National Park.<br/>
            1st place: $80<br/>
            2nd place: $50<br/>
            3rd place: $30 - get back full buy-in
          </p>
        </div>
      </div>
      </div>
    </div>
  )
}